var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F8CACA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_2577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 17,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33325,
    y: 2,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_2577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 14L6.33325 10L7.26659 9.06668L9.66659 11.4667V5.33334H10.9999V11.4667L13.3999 9.06668L14.3333 10L10.3333 14Z",
    fill: "#AA1F20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinPriceIcon);
export default __webpack_public_path__ + "static/media/MinPriceIcon.dd3e7807031b3edae0d0d91c43c677c4.svg";
export { ForwardRef as ReactComponent };